import { render, staticRenderFns } from "./Parallax.vue?vue&type=template&id=9188ab72"
import script from "./Parallax.vue?vue&type=script&lang=js"
export * from "./Parallax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9188ab72')) {
      api.createRecord('9188ab72', component.options)
    } else {
      api.reload('9188ab72', component.options)
    }
    module.hot.accept("./Parallax.vue?vue&type=template&id=9188ab72", function () {
      api.rerender('9188ab72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Parallax.vue"
export default component.exports